import { Role } from '@nemuru-eng/js-api-client';

import { UserEntity } from '@/entities/UserEntity';

export const isIbcCallCenterUser = (userEntity: UserEntity): boolean => userEntity.hasRole([Role.ROLE_IBC_CALL_CENTER]);

export const isIbcTlmkAgentUser = (userEntity: UserEntity): boolean => userEntity.hasRole([Role.ROLE_IBC_TLMK_AGENT]);

export const isIbcSalesRestrictedUser = (userEntity: UserEntity): boolean =>
  userEntity.hasRole([Role.ROLE_IBC_TLMK_AGENT, Role.ROLE_IBC_CALL_CENTER]);

// Only stands agents create applications (the stands flow); stands supervisors (ROLE_IBC_STANDS_CHANNEL) do not.
export const isIbcStandsAgentUser = (userEntity: UserEntity): boolean => userEntity.hasRole([Role.ROLE_IBC_STANDS_AGENT]);

export const isIbcStandsSupervisorUser = (userEntity: UserEntity): boolean =>
  userEntity.hasRole([Role.ROLE_IBC_STANDS_CHANNEL]);
